import React from 'react';
import ArtifactViewMainContentSignaturesComponentVersions from '~/artifact/containers/ArtifactViewMainContentSignaturesComponentVersions';
import ArtifactViewMainContentSignaturesComponentVersionDetails from '~/artifact/containers/ArtifactViewMainContentSignaturesComponentVersionDetails';
function ArtifactViewMainContentSignatures() {
  return (
    <div className="grid grid--full ph">
      <div className="grid__item col-1-1">
        <div className="grid">
          <div className="grid__item col-1-4 phone--col-1-1">
            <ArtifactViewMainContentSignaturesComponentVersions />
          </div>
          <div className="grid__item col-3-4 bo-l--1 border-color--muted phone--col-1-1 phone--bo-0 phone--pt">
            <ArtifactViewMainContentSignaturesComponentVersionDetails />
          </div>
        </div>
      </div>
    </div>
  );
}
export default ArtifactViewMainContentSignatures;
